/* OBS — AJAX Search Modal (stable, con eventi e freeze iniziale) */
(function () {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = document.documentElement;
  const body = document.body;

// PATCH: debounce cancellabile
const debounce = (fn, t = 250) => {
  let id;
  const wrapped = (...a) => {
    clearTimeout(id);
    id = setTimeout(() => fn.apply(null, a), t);
  };
  wrapped.cancel = () => clearTimeout(id);
  return wrapped;
};
  const OUT_MS = 800;

  const SPINNER_MIN_MS = 750;    // 700–800 ms “obbligatori”
  const EXIT_MS = 260;           // durata animazione uscita card

  let LAST_OPEN_TS = 0;
  let IS_CLOSING   = false;

  const modal   = $('#ObsSearchModal');
  if (!modal) return;

  const dialog  = $('.mo-search__dialog', modal);
  const form    = $('#ObsSearchForm', modal);
  const input   = $('#ObsSearchInput', modal);
  const spinner = $('#ObsSearchSpinner', modal);

  // ---- Stato interno
  let __spinMinActive = false;
  let __spinMinTimer  = 0;
  let __clearing = false;
  let __suppressChipLabelInInput = false; // quando true, non scriviamo il testo del chip nell'input
  let __lastVal  = '';                    // per rilevare passaggio non-vuoto -> vuoto

  // ---- Utility spinner con durata minima
  function spinnerStartMin() {
    clearTimeout(__spinMinTimer);
    __spinMinActive = true;
    spinner && spinner.classList.remove('hidden');
    modal && modal.classList.add('is-loading');
    modal && modal.classList.add('grid-hidden'); // nasconde la griglia finché gira
    __spinMinTimer = setTimeout(() => {
      __spinMinActive = false;
      spinnerStopIfReady();
    }, SPINNER_MIN_MS);
  }
  function spinnerStopIfReady() {
    if (__spinMinActive) return;
    spinner && spinner.classList.add('hidden');
    modal && modal.classList.remove('is-loading');
    if (modal && modal.classList.contains('grid-hidden')) {
      modal.classList.remove('grid-hidden');     // rivela la griglia
      requestAnimationFrame(() => animateResults()); // entrata con stagger
    }
  }

  // ---- Chip helpers
  function getDefaultChip(){
    return modal.querySelector('.mo-chip[data-default="1"]')
        || modal.querySelector('.mo-chip[data-chip]');
  }
  function getActiveOrDefaultChip(){
    return modal.querySelector('.mo-chip.is-active')
        || getDefaultChip();
  }
  function setActiveChip(ch){
    modal.querySelectorAll('.mo-chip').forEach(c => c.classList.toggle('is-active', c === ch));
  }

  // ---- Clear → vai alla chip di default, input visivamente vuoto
  function clearToDefaultChip(useAnim = true){
    if (__clearing) return;
    __clearing = true;
    
    debouncedPerform.cancel(); // PATCH: evita che un vecchio debounce riscriva l’input

    const chip = getDefaultChip();
    __suppressChipLabelInInput = true; // NON riportare il testo del chip nell'input
    __lastVal = ''; // stato interno coerente

    spinnerStartMin();

    const go = () => {
      input.value = '';       // svuota input visualmente
      refreshClear();

      if (chip) setActiveChip(chip); // attiva la chip di default

      perform();               // farà fallback al chip, ma senza scrivere nell'input
      __clearing = false;
    };

    if (useAnim) animateOutResults(go);
    else go();
  }

  // ---- UI helpers
  function refreshClear(){
    const clearBtn = form?.querySelector('.mo-search__clear');
    if (!clearBtn || !input) return;
    clearBtn.style.display = input.value.trim() ? 'inline-flex' : 'none';
  }
  function bumpAnimating(ms = 1000){
    root.classList.add('obs-search-animating');
    setTimeout(() => root.classList.remove('obs-search-animating'), ms);
  }

  // ---- Anim risultati
  function animateResults() {
    const box = $('#SearchProductGridContainer', modal);
    if (!box) return;
    box.classList.remove('obs-appear');
    void box.offsetWidth; // reset anim
    const items = box.querySelectorAll('li.grid__item, .grid .grid__item');
    items.forEach((el, i) => el.style.setProperty('--obs-stagger', `${i * 40}ms`));
    box.classList.add('obs-appear');
  }
  function animateOutResults(onDone){
    const box = $('#SearchProductGridContainer', modal);
    if (!box) { onDone && onDone(); return; }
    const items = box.querySelectorAll('li.grid__item, .grid .grid__item');
    if (!items.length) { onDone && onDone(); return; }
    box.classList.remove('obs-appear');
    items.forEach((el, i, arr) => el.style.setProperty('--obs-leave-stagger', `${(arr.length-1-i)*20}ms`));
    box.classList.add('obs-leave');
    const total = EXIT_MS + items.length*20 + 30;
    setTimeout(() => {
      box.classList.remove('obs-leave');
      onDone && onDone();
    }, total);
  }

  // ---- Apertura/chiusura
  function open(){
    const y = window.scrollY || window.pageYOffset || 0;
    body.style.setProperty('--obs-lock', `-${y}px`);
    root.classList.add('obs-search-open');
    body.classList.add('obs-search-open');
    body.dataset.obsLockY = String(y);

    modal.setAttribute('aria-hidden', 'false');

    window.__OBS_SEARCH_OPEN_TS = (window.performance && performance.now()) || Date.now();
    document.dispatchEvent(new CustomEvent('obs:search:open', { detail: { ts: window.__OBS_SEARCH_OPEN_TS } }));

    bumpAnimating(1100);

    LAST_OPEN_TS = Date.now();
    modal.classList.remove('closing');
    modal.classList.add('is-open');
    dialog && dialog.offsetHeight;
    input && input.focus({ preventScroll: true });
    if (input) {
      input.focus({ preventScroll: true });
      refreshClear();
      applyDefaultChipIfEmpty(); // su open: se vuoto, usa chip (l'input qui può essere riempito)
    }
  }
  function close(){
    debouncedPerform.cancel(); // PATCH: non eseguire ricerche mentre chiude
    if (!modal || !modal.classList.contains('is-open') || IS_CLOSING) return;
    IS_CLOSING = true;
    modal.classList.add('closing');

    const finish = () => {
      modal.classList.remove('is-open', 'closing');
      root.classList.remove('obs-search-open');
      body.classList.remove('obs-search-open');
      const y = parseInt(body.dataset.obsLockY || '0', 10);
      body.style.removeProperty('--obs-lock');
      delete body.dataset.obsLockY;
      window.scrollTo(0, y);
      modal.setAttribute('aria-hidden', 'true');

      IS_CLOSING = false;
      spinner && spinner.classList.add('hidden');
    };

    dialog && dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, OUT_MS + 120);
  }

  // ---- Default su open se input vuoto (input qui PUÒ mostrare il testo del chip)
  function applyDefaultChipIfEmpty(){
    if (!input || input.value.trim()) return;
    const first = getDefaultChip();
    if (!first) return;
    input.value = first.dataset.chip || first.textContent.trim();
    refreshClear();
    setActiveChip(first);
    spinnerStartMin();
    perform();
  }

  // ---- Event wiring
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-search]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  });

  // Click chip → imposta input col testo della chip, attiva chip e cerca
  modal.addEventListener('click', (e) => {
    const chip = e.target.closest('.mo-chip');
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    input.value = chip.dataset.chip || '';
    refreshClear();
    setActiveChip(chip);
    spinnerStartMin();
    perform();
  });

  // Close
  modal.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-close]');
    if (!closer) return;
    if (Date.now() - LAST_OPEN_TS < 280) return;
    e.preventDefault();
    close();
  });
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.defaultPrevented) return;
    const slash = e.key === '/';
    const cmdk  = (e.key.toLowerCase() === 'k') && (e.metaKey || e.ctrlKey);
    const typing = /input|textarea|select/i.test(e.target.tagName) || e.target.isContentEditable;
    if ((slash || cmdk) && !typing) { e.preventDefault(); open(); }
  });

  form.addEventListener('submit', (e) => e.preventDefault());
  const debouncedPerform = debounce(() => perform(), 320);

  // Digitazione: se diventa vuoto → default chip (input resta vuoto). Altrimenti normal debounce.
  input.addEventListener('input', () => {
    const now = input.value;
    const becameEmpty = !!__lastVal.trim() && !now.trim();

    if (becameEmpty){
      debouncedPerform.cancel(); // PATCH: stop al trigger pendente
      clearToDefaultChip(true);   // spinner + anim out + default chip, input vuoto
      __lastVal = '';             // coerente
      return;                     // evita doppia perform dal debounce
    }

    refreshClear();
    spinnerStartMin();
    debouncedPerform();
    __lastVal = now;
  });

  // Evento "search" (click sulla X nativa del campo search)
input.addEventListener('search', () => {
  if (!input.value.trim()){
    debouncedPerform.cancel();     // PATCH
    clearToDefaultChip(true);
  }
});

  // Click su "Cancella" (bottone testuale accanto all’input) → default chip, input vuoto
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#ObsSearchModal .mo-search__clear');
    if (!btn) return;
    e.preventDefault();
    clearToDefaultChip(true);
  });

  // ---- Ricerca
  function perform(){
    refreshClear();
    if (!modal.classList.contains('is-open')) return;

    let q = input.value.trim();

    // Fallback su chip (attiva → default). Se __suppressChipLabelInInput è true,
    // NON scriviamo il testo del chip nell'input (resta vuoto).
    if (!q){
      const chip = getActiveOrDefaultChip();
      if (chip){
        setActiveChip(chip);
        q = chip.dataset.chip || chip.textContent.trim();

        if (!__suppressChipLabelInInput){
          input.value = q;
          refreshClear();
        } else {
          input.value = '';
          refreshClear();
          __suppressChipLabelInInput = false; // reset per le ricerche successive
        }
      }
    }

    const params = new URLSearchParams();
    if (q) params.set('q', q);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');

    spinnerStartMin();

    const facetsEl = modal.querySelector('facet-filters-form');
    if (facetsEl && typeof facetsEl.renderPage === 'function') {
      facetsEl.renderPage(params.toString(), null, false);
    } else {
      const secId = $('#search-grid', modal)?.dataset?.id;
      const url = `/search?section_id=${secId}${params.toString() ? `&${params.toString()}` : ''}`;
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.text())
        .then(html => swapFromHTML(html))
        .catch(()=>{})
        .finally(()=>spinnerStopIfReady());
    }
  }

  // Dawn ha finito lo swap
  document.addEventListener('facets:updated', () => {
    if (!modal.classList.contains('is-open')) return;
    spinner && spinner.classList.add('hidden');
    animateResults();
    spinnerStopIfReady();
    window.__OBS_SEARCH_RESULTS_TS = (window.performance && performance.now()) || Date.now();
    document.dispatchEvent(new CustomEvent('obs:search:results', { detail: { ts: window.__OBS_SEARCH_RESULTS_TS } }));
    bumpAnimating(1100);
  });

  function swapFromHTML(html){
    const doc    = new DOMParser().parseFromString(html, 'text/html');
    const modal  = document.getElementById('ObsSearchModal'); // scope nel modal

    const incoming = doc.getElementById('SearchProductGridContainer');
    const current  = modal.querySelector('#SearchProductGridContainer');

    const cntSrc   = doc.getElementById('SearchCount');
    const cntDst   = modal.querySelector('#SearchCount');

    if (incoming && current) {
      const tmp = document.createElement('div');
      tmp.innerHTML = incoming.innerHTML;
      tmp.querySelectorAll('script, style, link[rel="stylesheet"]').forEach(n => n.remove());
      current.innerHTML = tmp.innerHTML;
    }

    if (cntSrc && cntDst) {
      cntDst.innerHTML = cntSrc.innerHTML;
    }

    window.__OBS_SEARCH_RESULTS_TS = (performance && performance.now()) || Date.now();
    document.dispatchEvent(new CustomEvent('obs:search:results', { detail: { ts: window.__OBS_SEARCH_RESULTS_TS } }));

    spinner && spinner.classList.add('hidden');
    animateResults();
    spinnerStopIfReady();
    bumpAnimating(1100);
  }

})();
